import { get, withUrl } from '@factorin/rest';

import { DocumentData } from './types';


interface EmissionDocument extends DocumentData {
    caption: string;
}

export enum EmissionStatus {
    acception = 'acception',
    active = 'active',
    closed = 'closed',
    other = 'other',
    failed = 'failed',
    upcoming = 'upcoming',
    processing = 'processing',
}

export interface EmissionItem {
    issuer: string;
    status: EmissionStatus;
    statusextended: string | null;
    circulationperiod: string;
    decision?: EmissionDocument;
    'decision_sign'?: EmissionDocument;
    result?: EmissionDocument;
    repayment?: EmissionDocument;
}

const emissionPart = withUrl('Emission');

export const emission = {
    list: get<void, EmissionItem[]>(() => emissionPart()),
};
